import React, { useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { AuthContext } from '../../../contexts/authContext'
import 'react-toastify/dist/ReactToastify.css'
import PassLogin from './editProfilePassLogin'
import SocialLogin from './editProfileSocialLogin'
import Layout from '../../common/layout/layout'

function EditProfile() {
  const authContext = useContext(AuthContext)

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col xs={12}>
              <h1 className="pageTitle">Edit Profile</h1>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="pt-3" data-testid="edit-forms">
              {authContext?.user?.providerData[0]?.providerId === 'phone' ? (
                <PassLogin />
              ) : (
                <SocialLogin />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default EditProfile
